import { render, staticRenderFns } from "./StaffShareBox.vue?vue&type=template&id=03f06dcd&scoped=true"
import script from "./StaffShareBox.vue?vue&type=script&lang=js"
export * from "./StaffShareBox.vue?vue&type=script&lang=js"
import style0 from "./StaffShareBox.vue?vue&type=style&index=0&id=03f06dcd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f06dcd",
  null
  
)

export default component.exports